export default "__VITE_ASSET__40fab727__"